import { styled } from '@mui/material/styles';
import Select, { selectClasses } from '@mui/material/Select';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

const CustomSelect = styled(Select)`
  & .${selectClasses.outlined} {
    padding: 9px 12px;
    line-height: 24px !important;
  }

  & .${outlinedInputClasses.notchedOutline} {
    borderColor: '#e0e2e8',
  }

  & .${outlinedInputClasses.notchedOutline}.${selectClasses.error} {
    borderColor: '#A72A2A',
  }

  & .${selectClasses.icon} {
    color: '#000000b2',
  },
`;

export default CustomSelect;
